import React from 'react'
import './ExtendedInfoAccordion.css'
import PersonalAndBackGroundInfo from './PersonalAndBackGroundInfo'
import Gallery from './Gallery'
import PersonTags from './PersonTags'
import PersonUpdates from './PersonUpdates'
import FavouritesAndCarrers from './FavouritesAndCarrers'
import AchievementsAndHonors from './Achivements'
import MovieHits from './MovieHits'
import ArticleReviewForm from './ArticleReviewForm'
import BasicInfoCreateEdit from './BasicInfoCreateEdit'

function AccordiansUi(props) {
  const {
    activeSection,
    handleSectionClick,
    setActiveSection,
    PersoninputData,
    personName,
    personNamete,
    error,
    setInputData,
    sendValueChangedBoolean,
    shortBio,
    shortBiote,
    setShortBiote,
    setShortBio,
    setPersonName,
    setPersonNamete,
    setWikipediaURL,
    valueChanged,
    fetchPersonData,
    personData,
    setLoader,
    wikipediaURL,
    personalAndBackGroundInfo,
    setPersonalAndBackGroundInfo,
    setFamilyAndRelationships,
    familyAndRelationships,
    setPersonFavorites,
    personFavorites,
    setPersonDataCareers,
    personDataCareers,
    setPersonalAssetsAndSocialMedia,
    personalAssetsAndSocialMedia,
    achievementsAndHonors,
    setAchievementsAndHonors,
    setBusinessVentures,
    setRumorsAndControversies,
    rumorsAndControversies,
    businessVentures,
    setPoliticsInfo,
    politicsInfo,
    mode,
    reviews,
    setReviews,
  } = props
  return (
    <div id='accordion'>
      <BasicInfoCreateEdit
        section='section1'
        activeSection={activeSection}
        handleSectionClick={handleSectionClick}
        setActiveSection={setActiveSection}
        PersoninputData={PersoninputData}
        personName={personName}
        personNamete={personNamete}
        error={error}
        setInputData={setInputData}
        sendValueChangedBoolean={sendValueChangedBoolean}
        shortBio={shortBio}
        shortBiote={shortBiote}
        setShortBio={setShortBio}
        setShortBiote={setShortBiote}
        setPersonNamete={setPersonNamete}
        setPersonName={setPersonName}
        setWikipediaURL={setWikipediaURL}
        valueChanged={valueChanged}
        wikipediaURL={wikipediaURL}
        personData={personData}
        fetchPersonData={fetchPersonData}
        setLoader={setLoader}
        mode={mode}
      />
      <Gallery
        section='section2'
        activeSection={activeSection}
        handleSectionClick={sectionId =>
          handleSectionClick({ sectionId, activeSection, setActiveSection, mode })
        }
        PersoninputData={PersoninputData}
        sendInputPersondata={setInputData}
        sendValuechangedBoolean={sendValueChangedBoolean}
        valueChanged={valueChanged}
        getUpdatedData={fetchPersonData}
        personData={personData}
        setLoader={setLoader}
      />
      <PersonUpdates
        section='section3'
        activeSection={activeSection}
        handleSectionClick={sectionId =>
          handleSectionClick({ sectionId, activeSection, setActiveSection, mode })
        }
        inputData={PersoninputData}
        movieData={personData}
        sendinputdata={setInputData}
      />
      <PersonTags
        section='section4'
        activeSection={activeSection}
        handleSectionClick={sectionId =>
          handleSectionClick({ sectionId, activeSection, setActiveSection, mode })
        }
        rendeedPersondata={personData}
      />
      <ArticleReviewForm
        section='section5'
        activeSection={activeSection}
        handleSectionClick={sectionId =>
          handleSectionClick({ sectionId, activeSection, setActiveSection, mode })
        }
        reviews={reviews}
        setReviews={setReviews}
        getUpdatedData={fetchPersonData}
        personData={personData}
        setLoader={setLoader}
      />
      <PersonalAndBackGroundInfo
        section='section6'
        activeSection={activeSection}
        handleSectionClick={sectionId =>
          handleSectionClick({ sectionId, activeSection, setActiveSection, mode })
        }
        setPersonalAndBackGroundInfo={setPersonalAndBackGroundInfo}
        personalAndBackGroundInfo={personalAndBackGroundInfo}
        sendInputPersondata={setInputData}
        sendValuechangedBoolean={sendValueChangedBoolean}
        personData={personData}
        getUpdatedData={fetchPersonData}
        setLoader={setLoader}
      />
      <FavouritesAndCarrers
        section='section7'
        activeSection={activeSection}
        handleSectionClick={sectionId =>
          handleSectionClick({ sectionId, activeSection, setActiveSection, mode })
        }
        setPersonalAndBackGroundInfo={setFamilyAndRelationships}
        personalAndBackGroundInfo={familyAndRelationships}
        personData={personData}
        label='familyAndRelationships'
        getUpdatedData={fetchPersonData}
        setLoader={setLoader}
      />
      <FavouritesAndCarrers
        section='section8'
        activeSection={activeSection}
        handleSectionClick={sectionId =>
          handleSectionClick({ sectionId, activeSection, setActiveSection, mode })
        }
        setPersonalAndBackGroundInfo={setPersonFavorites}
        personalAndBackGroundInfo={personFavorites}
        personData={personData}
        label='favourites'
        getUpdatedData={fetchPersonData}
        setLoader={setLoader}
      />
      <FavouritesAndCarrers
        section='section9'
        activeSection={activeSection}
        handleSectionClick={sectionId =>
          handleSectionClick({ sectionId, activeSection, setActiveSection, mode })
        }
        setPersonalAndBackGroundInfo={setPersonDataCareers}
        personalAndBackGroundInfo={personDataCareers}
        personData={personData}
        label='career'
        getUpdatedData={fetchPersonData}
        setLoader={setLoader}
      />
      <MovieHits
        section='section10'
        activeSection={activeSection}
        handleSectionClick={sectionId =>
          handleSectionClick({ sectionId, activeSection, setActiveSection, mode })
        }
        label='PersonMovieHits'
        personData={personData}
        PersoninputData={PersoninputData}
        sendInputdata={setInputData}
        getUpdatedData={fetchPersonData}
        setLoader={setLoader}
      />
      <FavouritesAndCarrers
        section='section11'
        activeSection={activeSection}
        handleSectionClick={sectionId =>
          handleSectionClick({ sectionId, activeSection, setActiveSection, mode })
        }
        setPersonalAndBackGroundInfo={setPersonalAssetsAndSocialMedia}
        personalAndBackGroundInfo={personalAssetsAndSocialMedia}
        personData={personData}
        label='personalAssetsAndSocialMedia'
        getUpdatedData={fetchPersonData}
        setLoader={setLoader}
      />
      <AchievementsAndHonors
        data={achievementsAndHonors}
        setData={setAchievementsAndHonors}
        activeSection={activeSection}
        section='section12'
        handleSectionClick={sectionId =>
          handleSectionClick({ sectionId, activeSection, setActiveSection, mode })
        }
        label='achievementsAndHonors'
        personData={personData}
        getUpdatedData={fetchPersonData}
        setLoader={setLoader}
      />
      <FavouritesAndCarrers
        section='section13'
        activeSection={activeSection}
        handleSectionClick={sectionId =>
          handleSectionClick({ sectionId, activeSection, setActiveSection, mode })
        }
        setPersonalAndBackGroundInfo={setRumorsAndControversies}
        personalAndBackGroundInfo={rumorsAndControversies}
        personData={personData}
        label='rumorsAndControversies'
        getUpdatedData={fetchPersonData}
        setLoader={setLoader}
      />
      <FavouritesAndCarrers
        section='section14'
        activeSection={activeSection}
        handleSectionClick={sectionId =>
          handleSectionClick({ sectionId, activeSection, setActiveSection, mode })
        }
        setPersonalAndBackGroundInfo={setBusinessVentures}
        personalAndBackGroundInfo={businessVentures}
        personData={personData}
        label='businessVentures'
        getUpdatedData={fetchPersonData}
        setLoader={setLoader}
      />
      <FavouritesAndCarrers
        section='section15'
        activeSection={activeSection}
        handleSectionClick={sectionId =>
          handleSectionClick({ sectionId, activeSection, setActiveSection, mode })
        }
        setPersonalAndBackGroundInfo={setPoliticsInfo}
        personalAndBackGroundInfo={politicsInfo}
        personData={personData}
        label='politicsInfo'
        getUpdatedData={fetchPersonData}
        setLoader={setLoader}
      />
    </div>
  )
}

export default AccordiansUi
